import React from 'react';
import { Link } from 'react-router-dom';
import defaultLogo from '../../images/logo.png';
import './EnConstruccion.css';

export default function EnConstruccion({ slug }) {
    return (
        <div className="ec-vidriera">
            <div className="ec-glow ec-glow-a" aria-hidden="true" />
            <div className="ec-glow ec-glow-b" aria-hidden="true" />

            <header className="ec-top">
                <img className="ec-logo" src={defaultLogo} alt="Logo" />
                <span className="ec-brand">SHOP</span>
            </header>

            <main className="ec-main">
                <div className="ec-cartel" aria-label="Cartel colgado: próximamente">
                    <span className="ec-cadena ec-cadena-izq" aria-hidden="true" />
                    <span className="ec-cadena ec-cadena-der" aria-hidden="true" />
                    <div className="ec-cartel-panel">
                        <span className="ec-cartel-eyebrow">En construcción</span>
                        <strong className="ec-cartel-titulo">Próximamente</strong>
                    </div>
                </div>

                <strong className="ec-cartel-titulo">Estamos levantando tu emprendimiento</strong>
                <p className="ec-sub">
                    Esta tienda todavía se está preparando. En unos minutos vas a poder
                    crear tu catálogo y gestionar tus pedidos.
                </p>

                <div className="ec-progreso" role="status" aria-label="Tienda en preparación">
                    <span className="ec-paso ec-paso-1" />
                    <span className="ec-paso ec-paso-2" />
                    <span className="ec-paso ec-paso-3" />
                    <span className="ec-paso ec-paso-4" />
                </div>
                <span className="ec-progreso-etiqueta">armando la tienda…</span>

                {slug ? <span className="ec-slug">Tienda · {slug}</span> : null}
            </main>

            <footer className="ec-pie">
                <Link to="/" className="ec-volver">← Volver al inicio</Link>
                <span className="ec-dominio">shop.solutiontechvp.com</span>
            </footer>
        </div>
    );
}